// Sections highlight
const sectionHightLight = () => {
  const sections = document.querySelectorAll(".collection-highlight");

  if (sections) {
    sections.forEach((s) => {
      const tabNav = s.querySelectorAll(".button-tab");
      const slider = s.querySelectorAll(".collection-slider");

      if (tabNav) {
        // Initial state
        slider[0].classList.add("active");
        tabNav[0].classList.add("active");

        // Button action
        tabNav.forEach((button, index) => {
          button.addEventListener("click", () => {
            tabNav.forEach((b) => {
              b.classList.remove("active");
            });
            button.classList.add("active");

            slider.forEach((i) => {
              i.classList.remove("active");
            });
            slider[index].classList.add("active");
          });
        });
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  sectionHightLight();
});
